import React, {useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';

import {useOutsideClickSimple} from "../../../misc/helperHooks";

const DiscountDropdown = (props) => {

  const {dropdownItems, selectItemClick, children, maxItems, useIntl, dropdownTitle} = props;

  const [opened, setOpened] = useState(false);
  const selectElement = useRef(null);

  useOutsideClickSimple(selectElement, () => {
    setOpened(false);
  });

  const handleSelectItemClick = (selectItem) => {
    if (selectItem.disabled) {
      return false;
    }
    selectItemClick(selectItem);
    setOpened(false);
  };

  const selectItemHeight = 33;
  let styles = {
    height: opened
      ? maxItems && (dropdownItems.length > maxItems)
        ? (maxItems * selectItemHeight) + (dropdownTitle ? 40 : 0) + "px"
        : (dropdownItems.length * selectItemHeight) + (dropdownTitle ? 40 : 0) + "px"
      : 0
  }

  return (
    <div className={"dr-container" + (opened ? " dr-container--opened" : "")} ref={selectElement}>
      <div className="dr-title" onClick={() => setOpened(true)}>
        {children || null}
      </div>
      <div className="dr-dropdown" style={styles}>
        {dropdownTitle ? <div className="dr-dropdown__list-item dr-dropdown__title bold flex flex--top flex--start nowrap">{dropdownTitle}</div> : null}
        <ul className={"dr-dropdown__list fix-ul text-left nowrap"
          + (maxItems && (dropdownItems.length > maxItems) ? " dr-dropdown__list--scroll" : "")}>
          {dropdownItems.map((selectItem, selectItemIndex) => {
            return (
              <li className="dr-dropdown__list-item"
                  key={selectItem.value + selectItemIndex}
                  onClick={() => handleSelectItemClick(selectItem)}>
                {selectItem.html || (
                  <span className={"dr-dropdown__list-item-text" + (selectItem.disabled ? " dr-dropdown__list-item-text--disabled" : "")}>
                    {useIntl ? <FormattedMessage id={selectItem.text}/> : selectItem.text}
                  </span>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

DiscountDropdown.propTypes = {
  dropdownItems: PropTypes.array.isRequired,
  selectItemClick: PropTypes.func.isRequired,
}

export default DiscountDropdown;
